import React from 'react';
import { View } from 'react-native-web';
import UploadImage from './ImageCompomemts/UploadImage';
import RegularText from '../Text/RegularText';

//= ========================================================================

const UploadContainer = ({
  globJSON,
  onConfigChanged,
  listObject,
  TwoButtonsInARow,
}) => (
  <View>
    <RegularText>{listObject.subHeadline}</RegularText>
    {listObject.fileId && (
    <UploadImage
      globJSON={globJSON}
      onConfigChanged={onConfigChanged}
      TwoButtonsInARow={TwoButtonsInARow}
      fileId={listObject.fileId}
    />
    ) }

  </View>
);
export default UploadContainer;
